import { FullscreenModal } from '@/components/global'
import { Button } from '@/components/priority'
import Flex from '@/components/priority/Flex/Flex'
import Text from '@/components/priority/Text/Text'
import { GetGlobalServiceInformationTemplatesNormalized } from '@messenger/types'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'

type ServiceTemplateDeleteModalProps = {
  template: GetGlobalServiceInformationTemplatesNormalized
  show: boolean
  setShow: (show: boolean) => void
  onDeleteTemplate: (
    template: GetGlobalServiceInformationTemplatesNormalized,
  ) => void
}
const ServiceTemplateDeleteModal = ({
  template,
  show,
  setShow,
  onDeleteTemplate,
}: ServiceTemplateDeleteModalProps) => {
  const { t } = useTranslation()

  return createPortal(
    <FullscreenModal show={[show, () => setShow(false)]} hideClose={false}>
      <Flex column full padding="32px" maxWidth="600px">
        <Text size="20px" weight="600" margin="10px 0 10px 0">
          {t('editor.serviceTemplates.deleteTemplateConfirmationTitle')}
        </Text>
        <Text size="16px" margin="10px 0 10px 0">
          {t('editor.serviceTemplates.deleteTemplateConfirmationDescription')}
        </Text>
        <Flex justify="flex-end" margin="10px 0 0 0" gap="8px">
          <Button onClick={() => setShow(false)}>
            {t('editor.serviceTemplates.cancelButton')}
          </Button>
          <Button
            primary
            onClick={() => onDeleteTemplate(template)}
            destructive
          >
            {t('editor.serviceTemplates.deleteTemplateButton')}
          </Button>
        </Flex>
      </Flex>
    </FullscreenModal>,
    document.body,
  )
}

export default ServiceTemplateDeleteModal
